export default "__VITE_ASSET__adc4d541__"